export default __webpack_public_path__ + "static/media/missing.8a714354.svg";